import * as signalR from "@microsoft/signalr";
import { MessageBar, MessageBarType, Stack } from 'office-ui-fabric-react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import React, { Component, Fragment } from 'react';
import { Data } from '../../../data/Data';
import { DataMessage } from '../../../data/DataMessage';
import { Immocom } from '../../../specifique/immocom';
import Header from './Header';
import MessageList from './MessageList';
import UserInput from './UserInput';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        string      idContactChiffre                    id chiffr� du contact rattach� � la conversation
        string      interlocuteur                       nom et pr�nom de l'interlocuteur
        string      nomOperation                        nom d'op�ration
        string      nomLot                              nom de lot
        bool        isOpen                              indique si fen�tre de tchat ouverte ou non
        string?     loginCompte                         login du compte utilis� par le backoffice
    METHODES :
        void        onDismiss                           m�thode appel�e � la fermeture du panel
        void        onNouveauMessage                    m�thode appel�e � la r�ception d'un nouveau message
        void        onOpen                              m�thode appel�e � l'ouverture
**********************************************************************************************************************
*/

class FicheTchat extends Component {

    static defaultProps = {
        estOnline: false,
        hubConnection: undefined,
        lastReceivedMessage: undefined,
    };

    _styles = {
        panel: {
            content: {
                height: "100%",
                paddingBottom: "0"
            }
        }
    };

    constructor(props) {
        super(props);
        this.objetState = {
            //estOnline: false,
            listeDesMessages: [],
            messageEnCoursDEnvoi: false,
            messageSelectionne: null,
        };
        this.state = this.objetState;
    };

    _chargementDonnees = () => {
        this.setState({ enCoursDeTraitement: true });
        DataMessage._chargerMessages(this.props.idContactChiffre)
            .then((responseFetch) => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeDesMessages = responseFetch.reponseAPIobjet;
                    this.setState({
                        listeDesMessages: listeDesMessages,
                        enCoursDeTraitement: false
                    });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _envoyerMessage = (message) => {

        const { hubConnection } = this.props;

        this.setState({ messageEnCoursDEnvoi: true });

        message.idContactChiffre = this.props.idContactChiffre;
        message.loginCompte = this.props.loginCompte;
        message.idOperation = this.props.idOperation;
        message.idReservation = this.props.idReservation;
        message.idMessageParent = this.state.messageSelectionne ? this.state.messageSelectionne.idMessage : null;
        message.texteMessageParent = this.state.messageSelectionne ? this.state.messageSelectionne.texte : "";

        if (!!hubConnection)
            hubConnection.invoke(
                "EnvoyerMessage",
                message.idContactChiffre,
                message.texte,
                message.fileName,
                message.fileData,
                message.idMessageParent,
                message.texteMessageParent,
                message.loginCompte,
                message.idOperation,
                message.idReservation
            ).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const nouveauMessage = responseFetch.reponseAPIobjet;
                    this._onNouveauMessage(nouveauMessage);
                    this._retirerMessageSelectionne();
                    this.setState({ errorMessage: "", messageEnCoursDEnvoi: false });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { messageEnCoursDEnvoi: false }, retourVerif, responseFetch);
                }
            });
    };

    _mettreAJourMessageSelectionne = (message) => () => {
        this.setState({ messageSelectionne: message });
    };

    _retirerMessageSelectionne = () => {
        this.setState({ messageSelectionne: null });
    };

    _onDismiss = () => {
        if (this.props.loginCompte)
            this.setState({
                listeDesMessages: [],
                messageSelectionne: null
            });
        this.props.onDismiss();
    };

    //_onCloseConnection = (error) => {
    //    console.log(error);
    //    this.setState({ estOnline: false });
    //};

    _onNouveauMessage = (nouveauMessage) => {
        if (nouveauMessage.idContactChiffre === this.props.idContactChiffre) { // Back-office : n'afficher le message que si la fen�tre de tchat correspond au client � l'origine du message
            let listeDesMessages = [...this.state.listeDesMessages];
            listeDesMessages.push(nouveauMessage);
            this.setState({ listeDesMessages: listeDesMessages });
        }
        if (this.props.onNouveauMessage)
            this.props.onNouveauMessage(nouveauMessage);
    };

    _onOpen = () => {
        // KP - 14/12/2020 - KO si _onNouveauMessage d�clench� avant _onOpen
        //if (!this.state.listeDesMessages.length) // Charger les messages si la liste des messages est vide (1�re ouverture, consultation des messages d'un autre client)
        this._chargementDonnees();
        if (this.props.onOpen) this.props.onOpen();
    };

    _renderHeader = () => {
        return <Stack>
            <Header
                titre={this.props.interlocuteur}
                onClose={this._onDismiss}
            />
            {!this.props.estOnline &&
                <MessageBar messageBarType={MessageBarType.error}>
                    Connection avec le serveur de messagerie impossible...
                </MessageBar>
            }
            {this.state.errorMessage &&
                <MessageBar messageBarType={MessageBarType.error}>
                    {this.state.errorMessage}
                </MessageBar>
            }
        </Stack>
    };

    _renderFooterContent = () => {
        return <UserInput
            messageEnCoursDEnvoi={this.state.messageEnCoursDEnvoi}
            messageSelectionne={this.state.messageSelectionne}
            onDeselectionMessage={this._retirerMessageSelectionne}
            estOnline={this.props.estOnline}
            onSubmit={this._envoyerMessage}
        />
    };

    componentDidUpdate = (prevProps) => {
        const { lastReceivedMessage } = this.props;
        if (JSON.stringify(prevProps.lastReceivedMessage) !== JSON.stringify(lastReceivedMessage))
            this._onNouveauMessage(lastReceivedMessage);
    };

    //componentDidMount = () => {
    //    const { loginCompte, idContactChiffre } = this.props;

    //    Data._getUrlEspaceClient()
    //        .then(responseFetch => {
    //            //const url = responseFetch.reponseAPIobjet;
    //            const url = "https://localhost:44345";
    //            this._hubConnection = new signalR.HubConnectionBuilder()
    //                .withUrl(`${url}/tchat`)
    //                .withAutomaticReconnect()
    //                .configureLogging(signalR.LogLevel.Information)
    //                .build();
    //        })
    //        .then(() => {
    //            this._hubConnection.start()
    //                .then(() => {
    //                    const appelDepuisBackOffice = loginCompte !== undefined;
    //                    this._hubConnection.invoke("Connect", loginCompte || idContactChiffre, appelDepuisBackOffice);
    //                    this.setState({ estOnline: true });
    //                })
    //                .catch((error) => console.error(error.toString()));
    //            this._hubConnection.on("NouveauMessage", this._onNouveauMessage);
    //            this._hubConnection.onclose((error) => { this._onCloseConnection(error); });
    //            this._hubConnection.onreconnecting((error) => { console.log(error); }); // TODO ?
    //            this._hubConnection.onreconnected((connectionId) => { console.log("Reconnected"); }); // TODO ?
    //        })
    //        .catch(err => console.log("Impossible d'�tablir la connexion avec le serveur."));
    //};

    render = () => {
        return <Fragment>

            <Panel
                hasCloseButton={false}
                isOpen={this.props.isOpen}
                onDismiss={this._onDismiss}
                onOpen={this._onOpen}
                onRenderHeader={this._renderHeader}
                onRenderFooterContent={this._renderFooterContent}
                styles={this._styles.panel}
                type={PanelType.medium}
            >
                {this.state.enCoursDeTraitement ?
                    <Stack verticalFill verticalAlign="center">
                        <Spinner label="Chargement des messages en cours..." size={SpinnerSize.large} />
                    </Stack> :
                    <MessageList
                        adminMode={this.props.loginCompte}
                        messages={this.state.listeDesMessages}
                        onSelectionMessage={this._mettreAJourMessageSelectionne}
                    />
                }
            </Panel>

        </Fragment>
    };

}

export default FicheTchat;